<div [class]="field.styleValue" [attr.lang]="metadataValue.language">
    <span class="text-value">
      {{ metadataValue.value | dsDate }}
    </span>
</div>
